// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__gdZ9K","iframe":"styles_iframe__R6NQz","loadingContainer":"styles_loadingContainer__Gz7mR"};